window.careersSiteFilter = () => {
  window.addEventListener('load', () => {
    bindFilterEvents();

    // Set filtered offers options
    $('.jsCareersFilterDep').find('[id="' + localStorage.getItem('depId') + '"]').trigger('click');
    $('.jsCareersFilterLoc').find('[id="location_' + localStorage.getItem('locId') + '"]').trigger('click');
    localStorage.clear();
  });
};

const bindFilterEvents = () => {
  const inputValue = '.jsGallerySearchLabel';
  const filterType = '.jsCareersFilterType';
  const filterName = '.jsCareersFilterName';
  const filterReset = '.jsCareersFilterReset';

  // choose item from filter list
  $(inputValue).on('click', function (e) {
    e.stopPropagation();

    $(this).parents(filterType).find(filterName).text($(this).text());

    if ($(this).parents(filterType).find(filterName).text() !== 'Choose location') {
      $(this).parents(filterType).find('.jsSlideList').slideUp();
      $(this).parents(filterType).find(filterReset).show();
      $(this).parents(filterType).find('.jsLinkButton').removeClass('active');
      $('.jsOverlay').hide();
    }
  });

  // rest filter
  $(filterReset).on('click', function (e) {
    e.stopPropagation();
    $(this).hide();
    $(this).parents(filterType).find('.jsSlideList').slideUp();
    $(this).parents(filterType).find('.jsLinkButton').removeClass('active');
    $('.Overlay').hide();

    if ($(this).parents(filterType).find('.jsCareersFilterDepartment').length > 0) {
      $(this).siblings(filterName).text('Choose department');
      $('input[name="department"]').each(function () {
        $(this).prop('checked', false);
      })
    }
    if ($(this).parents(filterType).find('.jsCareersFilterLocation').length > 0) {
      $(this).siblings(filterName).text('Choose location');
      $('input[name="location"]').each(function () {
        $(this).prop('checked', false);
      })
    }
  });

  // set visible name on input - department
  const checkInputDep = () => {
    let valDep = '';
    $('.jsCareersFilterDepartment').each((id, el) => {
      if (el.checked) {
        return valDep = el.value;
      }
    });
    return valDep
  };

  // set visible name on input - location
  const checkInputLoc = () => {
    let valLoc = '';
    $('.jsCareersFilterLocation').each((id, el) => {
      if (el.checked) {
        return valLoc = el.value;
      }
    });
    return valLoc;
  };

  // render offers
  $('.jsCareersFilterBtn').on('click', (e) => {
    e.stopPropagation();

    const locId = checkInputLoc();
    const depId = checkInputDep();
    const url = $(location).attr('href');
    const urlArray = url.split('=');
    const newurl = urlArray[0] + '=' + depId + urlArray[1] + '=' + locId;
    localStorage.setItem('depId', depId);
    localStorage.setItem('locId', locId);

    $.ajax({
      type: 'GET',
      url: newurl,
      success: (data) => {
      },
      error: (data) => {
      },
      headers: {
        'X-CSRFToken': getCookie('csrftoken')
      }
    })
  });
};
